export const PrintFormateNumber = (num, decimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const fixedNum = num.toFixed(decimals);

  return fixedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
